import React from 'react';

const features = [
  {
    title: 'Comprehensive Certificate Monitoring',
    content: [
      'Monitor public SSL certificates for any domain.',
      'Monitor private/internal certificates for your infrastructure.'
    ],
    glow: 'from-purple-400 via-pink-400 to-blue-400'
  },
  {
    title: 'Multi-Channel Notifications',
    content: [
      'Receive email alerts for expiring certificates.',
      'Get SMS notifications for critical expirations.',
      'Integrate with Slack for instant team alerts.',
      'Send notifications to Microsoft Teams channels.'
    ],
    glow: 'from-pink-400 via-orange-400 to-purple-400'
  },
  {
    title: 'Easy Setup & Management',
    content: [
      'Simple dashboard to add, view, and manage all your monitored domains and certificates.',
      'Support for both public and private certificate sources.'
    ],
    glow: 'from-blue-400 via-purple-400 to-pink-400'
  },
  {
    title: 'Security & Reliability',
    content: [
      'All sensitive data is encrypted and securely stored.',
      'Regular security audits and best practices.'
    ],
    glow: 'from-orange-400 via-pink-400 to-blue-400'
  },
  {
    title: 'SSL/TLS Consultancy Services',
    content: [
      'Fixing TLS/SSL Certificate issues',
      'Expert investigation of SSL/TLS issues for your domains or infrastructure.',
      'Custom deployment and configuration of SSL certificates.',
      'Remediation and best-practice guidance for security and uptime.',
      'One-on-one support for troubleshooting and compliance.'
    ],
    glow: 'from-orange-400 via-pink-400 to-blue-400'
  }
];

const borderColors = [
  '#a21caf', // purple
  '#ec4899', // pink
  '#6366f1', // violet
  '#f59e42'  // orange
];

const Features: React.FC = () => (
  <div className="max-w-5xl mx-auto py-16 px-4 sm:px-6 lg:px-8">
    <h1 className="text-3xl font-bold mb-12 text-center">Features</h1>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
      {features.map((feature, idx) => (
        <div
          key={feature.title}
          className={
            `relative rounded-2xl p-6 bg-white shadow-lg overflow-hidden border-2`
          }
          style={{
            borderColor: borderColors[idx % borderColors.length]
          }}
        >
          <div className="relative z-10">
            <h2 className="text-xl font-semibold mb-2 text-primary-700">{feature.title}</h2>
            <ul className="list-disc pl-6 text-gray-800">
              {feature.content.map((item, idx2) => (
                <li key={feature.title + '-' + idx2}>{item}</li>
              ))}
            </ul>
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default Features;
